import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '.';
import { Choices, Question } from '@/utils/types';

export const choicesApi = createApi({
	reducerPath: 'choicesApi',
	tagTypes: ['choices'],
	baseQuery: baseQuery,
	refetchOnMountOrArgChange: true,
	refetchOnReconnect: true,
	endpoints: (builder) => ({
		addChoice: builder.mutation({
			query: (body: Choices) => ({
				url: `question-choices`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['choices'],
		}),
		getChoiceById: builder.query({
			query: ({ id }: { id: string }) => ({
				url: `question-choices/${id}`,
			}),
		}),
		updateChoice: builder.mutation({
			query: ({ body, id }: { body: Choices; id: string }) => ({
				url: `question-choices/${id}`,
				method: 'PATCH',
				body,
			}),
			invalidatesTags: ['choices'],
		}),
		deleteChoice: builder.mutation({
			query: (id: string) => ({
				url: `question-choices/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['choices'],
		}),
	}),
});

export const { useAddChoiceMutation, useDeleteChoiceMutation, useGetChoiceByIdQuery, useUpdateChoiceMutation } =
	choicesApi;
